export default __webpack_public_path__ + "static/media/organization.c851f02d.png";